import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCostCenterResults from './ReportCostCenterResults'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCostCenterResults} />
    </Switch>
)

export default Components
